<template>
  <div class="btn-list" v-if="content">
    <ul class="list">
      <li v-for="(b,i) in content.btn" :key="i">
        <custom-btn
          :leftIcon="getIcon(b.icon)"
          :bgColor="{backgroundColor : b.background.color}"
          :textColor="b.color"
          :link="b.link"
          :tab="b.blank"
          :hide="b.hide"
        >{{b.label}}</custom-btn>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  },
  methods: {
    getIcon(icon) {
      if (icon) {
        return icon.icon.replace("fa-", "");
      }
    }
  }
};
</script>

<style lang="scss">
.btn-list {
  padding: 1em 0;
  padding-top: 2em;
  .list {
    width: $content-width;
    max-width: $max-width;
    padding: 1em auto;
    margin: auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    > li {
      margin: 0.5em 1em;
    }
  }
}
</style>
